import { fillArr, randomNum } from '@hglobal/common';
import { CommentReadStatus, FinancialRequestStatus } from '@pt/models';

import { GetRequestsRes } from '../models';

export function getRequestsMock(count = 14): GetRequestsRes {
  return {
    itemsCount: count,
    requests: fillArr(count, i => ({
      id: i,
      requestType: '',
      requestIdHash: '',
      requestId: i,
      date: new Date(),
      createdAt: new Date(),
      userStaffKey: 'STAF-198712',
      readStatus: CommentReadStatus.Unread,
      userTelegramUsername: '@a.sidorov',
      category: [
        'Missing Salary',
        'Incorrect Salary',
        'Overpayment',
        'Other Questions',
      ][randomNum(1, 0)],
      location: ['Ukraine', 'Poland'][randomNum(1, 0)],
      user: {
        fullName: 'Aleksander Sidorov',
        imageUrl: '',
        position: 'mock',
        email: 'test@test',
      },
      status: [
        FinancialRequestStatus.New,
        FinancialRequestStatus.InProgress,
        FinancialRequestStatus.Completed,
        FinancialRequestStatus.Rejected,
        FinancialRequestStatus.Canceled,
      ][randomNum(4)],
    })),
  };
}
